import { render, staticRenderFns } from "./SQuesFortyEight.vue?vue&type=template&id=206c15f8&scoped=true&"
import script from "./SQuesFortyEight.vue?vue&type=script&lang=js&"
export * from "./SQuesFortyEight.vue?vue&type=script&lang=js&"
import style0 from "./SQuesFortyEight.vue?vue&type=style&index=0&id=206c15f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c15f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCardText,VDialog})
